/* gkikz-cart-reservation-timer v2 — background watchdog: starts a 10-min hold when the cart has items
   and clears the cart at expiry whether or not the drawer is open (Palo Alto lazy-renders the drawer). */
(function(){
  var KEY='gkikz_cart_reservation_expires', DURATION=600000, URGENT=60000;
  var lastCount=null, expiring=false;
  var MARKUP='<div class="gkikz-reservation-timer is-hidden" data-gkikz-reservation-timer aria-live="polite"><span class="gkrt-l"><span class="gkrt-dot" aria-hidden="true"></span><span>Reserved for you</span></span><span class="gkrt-time" data-gkrt-time>10:00</span></div>';
  function pad(n){return n<10?'0'+n:''+n;}
  function fmt(ms){var s=Math.max(0,Math.floor(ms/1000));return pad(Math.floor(s/60))+':'+pad(s%60);}
  function getExpiry(){try{var v=localStorage.getItem(KEY);return v?parseInt(v,10):0;}catch(e){return 0;}}
  function setExpiry(t){try{localStorage.setItem(KEY,''+t);}catch(e){}}
  function clearExpiry(){try{localStorage.removeItem(KEY);}catch(e){}}
  function timers(){return document.querySelectorAll('[data-gkikz-reservation-timer]');}
  function hideTimers(){var e=timers();for(var i=0;i<e.length;i++)e[i].classList.add('is-hidden');}
  function ensureEl(){
    var body=document.querySelector('[data-cart-drawer-body]')||document.querySelector('.cart-drawer__body');
    if(!body||body.querySelector('[data-gkikz-reservation-timer]'))return;
    var tmp=document.createElement('div');tmp.innerHTML=MARKUP;var el=tmp.firstChild;if(el)body.insertBefore(el,body.firstChild);
  }
  function fetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'}).then(function(r){return r.json();});}
  /* Reconcile the saved expiry with the real cart: start a hold when items appear, drop it when empty.
     Never resets an existing (still-valid) expiry, so the countdown survives reloads + navigation. */
  function sync(){return fetchCart().then(function(c){lastCount=c.item_count;if(lastCount>0){if(!getExpiry())setExpiry(Date.now()+DURATION);}else{clearExpiry();}return c;}).catch(function(){});}
  function clearCart(){
    if(expiring)return;expiring=true;clearExpiry();hideTimers();
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin'}).then(function(){
      lastCount=0;
      var evs=['cart:updated','cart:refresh','cart:change','ajaxCart:afterCartLoad','theme:cart:change','theme:cart:added'];
      for(var i=0;i<evs.length;i++)document.dispatchEvent(new Event(evs[i]));
      var p=document.querySelector('[data-gk-fcart]');if(p)p.hidden=true;
      var open=document.body.classList.contains('js-drawer-open-cart')||document.body.classList.contains('drawer-open')||!!document.querySelector('.cart-drawer.is-open,#cart-drawer.is-open');
      if(typeof window.refreshCart==='function'){window.refreshCart();}
      else if(open){window.location.reload();}
    }).catch(function(){expiring=false;});
  }
  /* Watchdog: runs every second regardless of drawer state. When the hold has lapsed,
     double-check the live cart still has items, then empty it. */
  function watch(){
    var e=getExpiry();
    if(e&&Date.now()>=e){fetchCart().then(function(c){if(c.item_count>0){clearCart();}else{clearExpiry();lastCount=0;}}).catch(function(){});}
    setTimeout(watch,1000);
  }
  /* Visual: keeps the "Reserved for you" pill in sync whenever the drawer is open. */
  function visual(){
    ensureEl();
    var els=timers(),e=getExpiry();
    if(els.length&&e&&lastCount>0){
      var msLeft=e-Date.now();if(msLeft<0)msLeft=0;var urgent=msLeft<=URGENT;
      for(var i=0;i<els.length;i++){var el=els[i];el.classList.remove('is-hidden');var t=el.querySelector('[data-gkrt-time]');if(t)t.textContent=fmt(msLeft);el.classList.toggle('is-urgent',urgent);el.classList.toggle('is-pulsing',urgent);}
    }else{hideTimers();}
    setTimeout(visual,250);
  }
  function start(){
    sync();watch();visual();
    var evs=['cart:added','cart:updated','cart:refresh','cart:change','ajaxCart:afterCartLoad','theme:cart:change','theme:cart:added'];
    for(var i=0;i<evs.length;i++)document.addEventListener(evs[i],sync);
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[name="add"],[data-add-to-cart],.add-to-cart');if(a)setTimeout(sync,700);});
    document.addEventListener('visibilitychange',function(){if(!document.hidden)sync();});
    window.addEventListener('pageshow',sync);
    setInterval(sync,15000);
  }
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
})();